export const environment = 'development'
// export const environment = 'production'

export const baseURL = {
    development:'https://api.lms.embifi.in/api/v1',
    production:'https://prod.api.lms.embifi.in/api/v1'
}